module.exports = __webpack_public_path__ + "img/flower-market.82bba9fe.svg";